// extracted by mini-css-extract-plugin
module.exports = {"table":"styles-module__table___2QQ8-","container":"styles-module__container___3oO6l"};